export function formatCurrency(amount: number | null | undefined): string {
  if (amount == null) return "0,00 €";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
}

// Montant en centimes (API) → euros formatés.
export function formatCents(cents: number | null | undefined): string {
  return formatCurrency(cents == null ? 0 : cents / 100);
}

export function formatNumber(value: number | null | undefined): string {
  if (value == null) return "0";
  return value.toLocaleString("fr-FR");
}

export function formatDate(timestamp: number | string | undefined | null): string {
  if (!timestamp) return "-";
  return new Date(timestamp).toLocaleString("fr-FR");
}

// Date ISO (YYYY-MM-DD) → « 4 septembre 2026 » ; renvoie la chaîne telle quelle si invalide.
export function formatDateFr(iso: string | null | undefined): string {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso ?? "-";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
}

// Jour civil à Paris (YYYY-MM-DD), même règle que `parisDay` côté API : les
// exports arrêtés « à aujourd'hui » doivent viser la même date des deux côtés.
const PARIS_DAY = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit" });
export function parisToday(): string {
  return PARIS_DAY.format(new Date());
}

